import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig,
    ParmConfigDel,
    ParmConfigAdd
} from '@api/commonApi.js';

let consts = {
    timeLabel1: "寄出日期",
    timeLabel2: "收件日期",
};

export default {
    components: {},
    props: {
        isReadOnly: {
            default () {
                return false;
            }
        }
    },
    mounted() {

    },
    computed: {
        showByCS() {
            if (this.form.ContractStatusName == this.ContractStatusMap[1].name) {
                this.timeStr = consts.timeLabel2;
                return true;
            }
            this.timeStr = consts.timeLabel1;
            return false;
        },
        ContractStatusMap() {
            return this.$store.state.ContractStatusMap;
        }
    },
    data() {
        return {
            ContractId: "",
            timeStr: consts.timeLabel1,
            Logistics: [],
            checkedHthList: [],
            dialogContent: "",
            visibleShow: false,
            btnLoading: false,
            visiable1: false,
            hello: "",
            AreaList: [],
            Logistics: [],
            form: this.initData()
        };
    },
    watch: {

    },
    methods: {
        initData() {
            return cloneDeep({
                AgentId: "",
                "AgentAreaIds": "",
                ContractStatusName: "寄出",
                "ContractStatus": 1,
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeAdress": "",
                "LogisticsId": "",
                "LogisticsCode": "",
                "ConsigneeTime": "",
                "Remark": ""
            });
        },
        show(options) {

            let opts = $.extend({}, {
                AgentId: "",
                ContractId: "",
                isAdd: false,
                isReadOnly: false
            }, options);

            this.visiable1 = true;
            this.form.AgentId = opts.AgentId;
            this.getHthList();
            this.initLogistics();

            if (opts.isReadOnly) {
                this.ContractId = opts.ContractId;
                this.loadData(opts);
            }

            if (opts.isAdd) {
                this.setDefault(opts);
            }

        },
        changeStatus() {

        },
        showDialog() {
            this.visibleShow = true;
        },
        initLogistics() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: 10,
            };

            GetParmConfig(params).then(res => {
                util.doResult(this, res, () => {
                    this.Logistics = res.data.Data;
                })
            });

        },
        dialogClosed() {
            this.dialogContent = "";
            this.visibleShow = false;
        },
        getHthList() {

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: this.form.AgentId
            };

            let $msg = this.$message({
                message: '正在获取合同号数据，请稍后...',
                duration: 0
            });

            $http.get("api/Agent/GetAgentAreasByAgentId", params).then(res => {
                $msg.close();
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.$nextTick(() => {
                        this.AreaList = Data;
                    });
                });
            });
        },
        addLogistics() {
            var para = {
                ParmType: 10,
                ParmName: this.dialogContent
            };
            ParmConfigAdd(para).then(res => {
                util.doResult(this, res, () => {
                    this.getLogistics("1");
                    this.dialogContent = "";
                    this.visibleShow = false;
                });
            });
        },
        delLogistics(item) {
            let para = {
                Ids: item.Id
            };
            ParmConfigDel(para).then(res => {
                util.doResult(this, res, () => {
                    this.getLogistics();
                    for (var i = 0; i < this.Logistics.length; i++) {
                        if (this.Logistics[i].Id == item.Id) {
                            this.form.LogisticsId = "";
                        }
                    }
                });
            });
        },
        getLogistics(type) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                ParmType: 10,
            };

            GetParmConfig(para).then(res => {
                util.doResult(this, res, () => {
                    this.Logistics = res.data.Data;
                    if (type == "1") {
                        this.form.LogisticsId = this.Logistics[this.Logistics.length - 1].Id;
                    }
                });
            });
        },
        close() {
            this.visiable1 = false;
        },
        closeCallBack() {
            this.form = this.initData();
            this.AreaList = [];
            this.checkedHthList = [];
        },
        setDefault(opts) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: opts.AgentId
            };
            //Agent/LoadAgentForNewContract
            $http.get('api/Agent/LoadAgentForNewContract', params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = Object.assign({}, this.form, Data);
                });
            });
        },
        loadData(opts) {},
        submitfn() {

            let rules = [{
                name: "合同号",
                value: this.checkedHthList,
                required: true
            }];

            if (!this.showByCS) {
                rules.push({
                    name: "收件人",
                    value: this.form.Consignee,
                    required: true
                });
                rules.push({
                    name: "收件人电话",
                    value: this.form.ConsigneeTel,
                    phone: true
                });
                rules.push({
                    name: "收件地址",
                    value: this.form.ConsigneeAdress,
                    required: true
                });
                rules.push({
                    name: "物流货快递单号",
                    value: this.form.LogisticsCode,
                    required: true
                });
            }

            rules.push({
                name: "物流货快递名称",
                value: this.form.LogisticsId,
                required: true
            });

            rules.push({
                name: this.timeStr,
                value: this.form.ConsigneeTime,
                required: true
            });

            let flag = util.checkForm({
                ele: this,
                rules: rules
            });

            if (!flag) {
                return false;
            }

            if (this.showByCS) {
                this.form.Consignee = "";
                this.form.ConsigneeTel = "";
                this.form.ConsigneeAdress = "";
                //this.form.LogisticsCode = "";
            }

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };

            // let arr = [];
            // for (let i = 0; i < this.checkedHthList.length; i++) {
            //     arr.push(util.getItemByIdInArr(this.checkedHthList[i], this.AreaList, 'ContractNumber').Id);
            // }
            console.log(this.checkedHthList)
            this.form.AgentAreaIds = this.checkedHthList.join(",");
            this.form.ContractStatus = util.getItemByIdInArr(this.form.ContractStatusName, this.ContractStatusMap, 'name').id;

            $http.post('api/Agent/AgentAreaContractAdd', Object.assign({}, params, $.extend({}, this.form, {
                ConsigneeTime: util.time2str((this.form.ConsigneeTime))
            }))).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                });
                this.$emit('reloadZtList');
                this.visiable1 = false;
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMFormatAgent/components/optContractStatus/vm.js